/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Note_ExportInputs */

const en_hub_note_export = /** @type {(inputs: Hub_Note_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One request per format. Every bundle ships a README that spells out how features, tasks, acceptance criteria and owned files map onto the target tool.`)
};

const id_hub_note_export = /** @type {(inputs: Hub_Note_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu permintaan per format. Tiap bundel membawa README yang menjelaskan pemetaan fitur, task, kriteria penerimaan, dan berkas milik task ke alat tujuan.`)
};

/**
* | output |
* | --- |
* | "One request per format. Every bundle ships a README that spells out how features, tasks, acceptance criteria and owned files map onto the target tool." |
*
* @param {Hub_Note_ExportInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_note_export = /** @type {((inputs?: Hub_Note_ExportInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Note_ExportInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_note_export(inputs)
	return en_hub_note_export(inputs)
});